<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Base>
  <template v-slot:content>
    <div class="card mb-5 mb-xl-10">
      <div class="card-body pt-9 pb-0">
        <Loading v-if="isLoading"></Loading>
        <div v-else-if="partner" class="d-flex flex-wrap flex-sm-nowrap mb-3">
          <div class="me-7 mb-4">
            <div class="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
              <img v-if="partner && partner.photo" :src="uploadRoot + partner.photo" alt="image" class="object-cover" />
              <div v-else
                class="w-100px h-100px h-lg-175px w-lg-160px d-flex align-items-center justify-content-center shadow-xs rounded">
                <i class="fad fa-user fs-5x"></i>
                <!--                                    <img  alt="image" class="object-cover" style="opacity: 0">-->
              </div>
              <!--                <div :class="{-->
              <!--                                'bg-success': contract.status === CONSTANTS.CONTRACT_STATUS.ONGOING,-->
              <!--                                'bg-warning': contract.status === CONSTANTS.CONTRACT_STATUS.QUOTATION,-->
              <!--                                'bg-danger': contract.status === CONSTANTS.CONTRACT_STATUS.TERMINATED,-->
              <!--                                'bg-primary': contract.status === CONSTANTS.CONTRACT_STATUS.SUSPENDED-->
              <!--                            }"-->
              <!--                     class="position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px">-->
              <!--                </div>-->
            </div>
          </div>
          <div class="flex-grow-1">
            <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center mb-2">
                  <div class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1">
                    {{ partner.name }}
                  </div>
                </div>
                <div class="d-flex flex-wrap fw-bold fs-2 pe-2">
                  {{ partner.code }}
                </div>
                <div class="d-flex flex-wrap fw-bold fs-2 pe-2"></div>
              </div>
              <div>
                <div v-b-modal="'editPartner'" class="btn btn-primary">
                  Modifier
                </div>
              </div>
            </div>
            <div class="d-flex flex-wrap flex-stack">
              <div class="d-flex flex-column flex-grow-1 pe-8">
                <div class="d-flex flex-wrap">
                  <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                    <div class="d-flex align-items-center">
                      <span class="svg-icon svg-icon-3 svg-icon-success me-2">
                        <i class="fad fa-coins"></i>
                      </span>
                      <div class="fs-2 fw-bolder counted" data-kt-countup="true" data-kt-countup-prefix="$"
                        data-kt-countup-value="4500">
                        ---
                      </div>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">Solde</div>
                  </div>

                  <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                    <div class="d-flex align-items-center">
                      <span class="svg-icon svg-icon-3 svg-icon-success me-2">
                        <i class="fad fa-coins"></i>
                      </span>
                      <div class="fs-2 fw-bolder counted" data-kt-countup="true" data-kt-countup-prefix="$"
                        data-kt-countup-value="4500">
                        ---
                      </div>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">Commission</div>
                  </div>

                  <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                    <div class="d-flex align-items-center">
                      <span class="svg-icon svg-icon-3 svg-icon-success me-2">
                        <i class="fad fa-coins"></i>
                      </span>
                      <div class="fs-2 fw-bolder counted">---</div>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">
                      Valeur Client
                    </div>
                  </div>
                </div>
                <!--end::Stats-->
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Info-->
        </div>
      </div>
    </div>

    <!-- Section principale des onglets -->
    <div class="card">
      <div class="card-body">
        <b-tabs active-nav-item-class="" active-tab-class=""
          nav-wrapper-class="nav nav-stretch border-0 nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap flex-grow-1">
          <!-- Onglet Contrats -->
          <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'" @click="loadContracts">
            <template #title>
              <div class="d-flex align-items-center">
                <i class="fad fa-layer-group fs-2 me-2"></i>
                {{ trans("Contrats") }}
              </div>
            </template>
            <div>
              <table class="table table-striped gy-3 gs-3">
                <thead>
                  <tr class="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200">
                    <th>Type</th>
                    <th>Période</th>
                    <th>Montant/Reste</th>
                    <th>Apporteur</th>
                    <th>Agent</th>
                    <th>Statut</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loadingContracts">
                    <td colspan="7">
                      <Loading />
                    </td>
                  </tr>
                  <tr v-for="contract in contracts" :key="'c_' + contract.uuid">
                    <!-- Contenu du contrat -->
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <!-- Onglet Agences -->
          <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'">
            <template #title>
              <div class="d-flex align-items-center">
                <i class="fad fa-building fs-2 me-2"></i>
                {{ trans("Agences") }}
              </div>
            </template>
            <div>
              <div class="d-flex justify-content-end">
                <input v-model="searchAgency" class="form-control" placeholder="Rechercher" type="text" />
              </div>
              <PartnerTree v-if="partner" :partner="partner" :search="searchAgency" @createSub="createSub"
                @delete="deletePartner" @edit="editAgency" />
            </div>
          </b-tab>

          <!-- Onglet Tenants (visible uniquement pour les managers) -->
          <b-tab v-if="hasRole('ROLE_MANAGER')" :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'"
            @click="loadTenants">
            <template #title>
              <div class="d-flex align-items-center">
                <i class="fad fa-database fs-2 me-2"></i>
                {{ trans("Tenants") }}
              </div>
            </template>
            <div>
              <b-tabs
                nav-wrapper-class="bg-white px-10 mb-10 rounded-bottom nav nav-stretch border-0 nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap flex-grow-1">
                <b-tab v-for="tenant in tenants" :key="tenant.id"
                  :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'">
                  <template #title>
                    {{ tenant.label }}
                  </template>
                  <div class="card">
                    <div class="card-body">
                      <template v-if="partner.tenants.includes(tenant.code)">
                        <RoleLine v-for="roleItem in roles" :key="roleItem.id" :role="roleItem" @toggle="toggleRole"
                          :tenant="tenant" :user="partner" />

                        <div class="d-flex justify-content-center m-20">
                          <button class="btn btn-danger" @click="toggleTenant(tenant)">
                            Retirer l'accès au tenant {{ tenant.label }}
                          </button>
                        </div>
                      </template>
                      <template v-else>
                        <div class="d-flex justify-content-center p-20 bg-light-primary rounded m-20">
                          <button class="btn btn-primary" @click="toggleTenant(tenant)">
                            Autoriser l'accès au tenant {{ tenant.label }}
                          </button>
                        </div>
                      </template>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </b-tab>

          <!-- Onglet Liens -->
          <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'" @click="loadLinkData">
            <template #title>
              <div class="d-flex align-items-center">
                <i class="fad fa-link fs-2 me-2"></i>
                {{ trans("Liens") }}
              </div>
            </template>
            <div class="p-10">
              <div class="d-flex justify-content-between align-items-center mb-5">
                <button class="btn btn-primary btn-lg" v-b-modal="'createCustomLink'" :disabled="!partner">
                  <i class="fad fa-plus-circle me-2"></i>
                  Créer un lien personnalisé
                </button>
                <button v-if="links.length === 0" class="btn btn-success" :disabled="isGeneratingLinks || !partner"
                  @click="generateAllShortLinks">
                  <i class="fad" :class="isGeneratingLinks ? 'fa-spinner fa-spin' : 'fa-magic'"></i>
                  {{ isGeneratingLinks ? 'Génération...' : 'Générer tous les liens courts' }}
                </button>
              </div>

              <!-- Filtres de recherche -->
              <div class="row g-3 mb-5 align-items-end">
                <div class="col-md-3">
                  <label class="form-label fw-bold">Plateforme</label>
                  <select v-model="search.platform" @change="loadLinks" class="form-select">
                    <option :value="null">Toutes les plateformes</option>
                    <option v-for="platform in platforms" :key="platform.code" :value="platform.code">
                      {{ platform.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold">Formulaire</label>
                  <b-dropdown class="w-100" no-caret variant="outline-secondary">
                    <template v-slot:button-content>
                      <div class="d-flex justify-content-between align-items-center w-100">
                        <template v-if="!search.survey">
                          Tous les formulaires
                        </template>
                        <template v-else>
                          {{surveys.find(s => s.slug === search.survey)?.label || search.survey}}
                        </template>
                        <i class="fad fa-angle-down"></i>
                      </div>
                    </template>
                    <b-dropdown-text class="p-0" style="min-width: 300px">
                      <div class="p-2">
                        <input v-model="filterSurveySearch" class="form-control form-control-sm mb-2"
                          placeholder="Rechercher un formulaire..." type="text" />
                      </div>
                      <div style="max-height: 250px; overflow-y: auto">
                        <div class="px-3 py-2 cursor-pointer hover-bg-light" :class="{ 'bg-light': !search.survey }"
                          @click="search.survey = null; loadLinks()">
                          <div class="fw-bold">Tous les formulaires</div>
                        </div>
                        <template v-for="survey in surveys">
                          <div v-if="
                            empty(filterSurveySearch) ||
                            survey.label.toLowerCase().includes(filterSurveySearch.toLowerCase()) ||
                            survey.slug.toLowerCase().includes(filterSurveySearch.toLowerCase())
                          " :key="survey.slug" :class="{ 'bg-light': search.survey === survey.slug }"
                            class="px-3 py-2 cursor-pointer hover-bg-light"
                            @click="search.survey = survey.slug; loadLinks()">
                            <div class="fw-bold">{{ survey.label }}</div>
                            <div class="text-muted small">{{ survey.slug }}</div>
                          </div>
                        </template>
                      </div>
                    </b-dropdown-text>
                  </b-dropdown>
                </div>
                <div class="col-md-3">
                  <label class="form-label fw-bold">Agent</label>
                  <b-dropdown class="w-100" no-caret variant="outline-secondary">
                    <template v-slot:button-content>
                      <div class="d-flex justify-content-between align-items-center w-100">
                        <template v-if="!search.agent">
                          Tous les agents
                        </template>
                        <template v-else>
                          {{users.find(u => u.code === search.agent)?.name || search.agent}}
                        </template>
                        <i class="fad fa-angle-down"></i>
                      </div>
                    </template>
                    <b-dropdown-text class="p-0" style="min-width: 300px">
                      <div class="p-2">
                        <input v-model="filterAgentSearch" class="form-control form-control-sm mb-2"
                          placeholder="Rechercher un agent..." type="text" />
                      </div>
                      <div style="max-height: 250px; overflow-y: auto">
                        <div class="px-3 py-2 cursor-pointer hover-bg-light" :class="{ 'bg-light': !search.agent }"
                          @click="search.agent = null; loadLinks()">
                          <div class="fw-bold">Tous les agents</div>
                        </div>
                        <template v-for="user in users">
                          <div v-if="
                            empty(filterAgentSearch) ||
                            (!empty(user.name) && user.name.toLowerCase().includes(filterAgentSearch.toLowerCase())) ||
                            user.code.toLowerCase().includes(filterAgentSearch.toLowerCase())
                          " :key="user.code" :class="{ 'bg-light': search.agent === user.code }"
                            class="px-3 py-2 cursor-pointer hover-bg-light"
                            @click="search.agent = user.code; loadLinks()">
                            <div class="fw-bold">{{ user.name }}</div>
                            <div class="text-muted small">{{ user.code }}</div>
                          </div>
                        </template>
                      </div>
                    </b-dropdown-text>
                  </b-dropdown>
                </div>
                <div class="col-md-3">
                  <button @click="resetFilters" class="btn btn-secondary w-100">
                    <i class="fad fa-redo me-2"></i>
                    Réinitialiser
                  </button>
                </div>
              </div>
            </div>






            <div>
              <table
                class="table g-2 table-head-custom text-center table-head-bg table-borderless table-vertical-center table-hover table-striped">
                <thead>
                  <tr>
                    <th>Plateforme</th>
                    <th>Formulaire</th>
                    <th>Agent</th>
                    <th>Expiration</th>
                    <th>Accès</th>
                    <th>Lien</th>
                    <th>Qr Code</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="link in links" :key="link.id">
                    <td>
                      {{ link.platform }}
                    </td>
                    <td>
                      {{ link.survey }}
                    </td>
                    <td>
                      {{ link.agent }}
                    </td>
                    <td>
                      <template v-if="link.expireAt">
                        {{ datify(link.expireAt) }}
                      </template>
                    </td>
                    <td>
                      <div v-if="link.role" class="badge badge-primary">
                        {{ link.role }}
                      </div>
                    </td>
                    <td>
                      {{ link.short }}
                    </td>
                    <td>
                      <b-dropdown v-if="link.short" btnClass="btn-icon" no-caret right size="sm" toggle-class="btn-icon"
                        variant="primary">
                        <template v-slot:button-content>
                          <i class="fad fa-qrcode fs-2"></i>
                        </template>
                        <b-dropdown-text class="w-300px" tag="div">
                          <a :href="link.short" class="text-center d-flex justify-content-center" target="_blank">
                            <vue-qr :autoColor="true" :size="300" :text="link.short" :whiteMargin="true"
                              class="rounded position-relative" colorDark="black" colorLight="white"></vue-qr>
                          </a>
                        </b-dropdown-text>
                      </b-dropdown>

                      <button v-if="link.agent" class="ms-2 btn btn-warning btn-sm btn-icon"
                        @click="sendEmail(link.agent, link.short)">
                        <i class="fad fa-send"></i>
                      </button>

                      <button class="ms-2 btn btn-danger btn-sm btn-icon" @click="deleteCustomLink(link)">
                        <i class="fad fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <Pagination :itemLength="links.length" :matchCount="matchCount" v-model="search.page" showEmpty="false"
                class="p-10" :perPage="search.max" :key="'pagination_' + search.page" @input="loadLinkList()">
              </Pagination>
            </div>

            <div v-if="partner" class="p-10">
              <b-tabs>
                <b-tab>
                  <template #title> Par Plateforme</template>
                  <template #default>
                    <div class="border-1 d-flex flex-wrap">
                      <div :set="(url = getUrlPlatform({
                        name: 'comparateur-index',
                        query: { source: partner.code },
                      }))
                        " class="position-relative rounded border-1 border-dashed m-5 p-5">
                        <div class="fw-bolder text-uppercase my-5 w-100 text-center">
                          Backoffice
                        </div>

                        <!-- Lien minifié si disponible -->
                        <div v-if="generatedLinks.platform.backoffice" class="mb-3 text-center">
                          <div class="badge badge-success fs-6 p-3">
                            <i class="fad fa-check-circle me-2"></i>
                            Lien court généré
                          </div>
                          <div class="mt-2">
                            <a :href="generatedLinks.platform.backoffice" target="_blank" class="fw-bolder">
                              {{ generatedLinks.platform.backoffice }}
                            </a>
                            <button class="btn btn-sm btn-icon btn-light-primary ms-2"
                              @click="copyToClipboard(generatedLinks.platform.backoffice)" v-b-tooltip.hover
                              title="Copier le lien">
                              <i class="fad fa-copy"></i>
                            </button>
                          </div>
                        </div>

                        <b-dropdown btnClass="btn-icon" no-caret size="sm" toggle-class="btn-icon" variant="primary">
                          <template v-slot:button-content>
                            <i class="fad fa-qrcode fs-2"></i>
                          </template>
                          <b-dropdown-text class="w-300px" tag="div">
                            <a :href="generatedLinks.platform.backoffice || url"
                              class="text-center d-flex justify-content-center" target="_blank">
                              <vue-qr :autoColor="true" :size="300" :text="generatedLinks.platform.backoffice || url"
                                :whiteMargin="true" class="rounded position-relative" colorDark="black"
                                colorLight="white"></vue-qr>
                            </a>
                          </b-dropdown-text>
                        </b-dropdown>
                        <div></div>
                      </div>

                      <div :set="(url = getUrlComparator(partner.code))"
                        class="position-relative rounded border-1 border-dashed m-5 p-5">
                        <a :href="url" class="text-center d-flex justify-content-center" target="_blank">
                        </a>
                        <div class="fw-bolder text-uppercase my-5 w-100 text-center">
                          Comparateur
                        </div>

                        <!-- Lien minifié si disponible -->
                        <div v-if="generatedLinks.platform.comparator" class="mb-3 text-center">
                          <div class="badge badge-success fs-6 p-3">
                            <i class="fad fa-check-circle me-2"></i>
                            Lien court généré
                          </div>
                          <div class="mt-2">
                            <a :href="generatedLinks.platform.comparator" target="_blank" class="fw-bolder">
                              {{ generatedLinks.platform.comparator }}
                            </a>
                            <button class="btn btn-sm btn-icon btn-light-primary ms-2"
                              @click="copyToClipboard(generatedLinks.platform.comparator)" v-b-tooltip.hover
                              title="Copier le lien">
                              <i class="fad fa-copy"></i>
                            </button>
                          </div>
                        </div>

                        <b-dropdown btnClass="btn-icon" no-caret size="sm" toggle-class="btn-icon" variant="primary">
                          <template v-slot:button-content>
                            <i class="fad fa-qrcode"></i>
                          </template>
                          <b-dropdown-text class="w-300px" tag="div">
                            <a :href="generatedLinks.platform.comparator || url"
                              class="text-center d-flex justify-content-center" target="_blank">
                              <vue-qr :autoColor="true" :size="300" :text="generatedLinks.platform.comparator || url"
                                :whiteMargin="true" class="rounded position-relative" colorDark="black"
                                colorLight="white"></vue-qr>
                            </a>
                          </b-dropdown-text>
                        </b-dropdown>

                        <div></div>
                      </div>
                    </div>
                  </template>
                </b-tab>
                <b-tab @click="loadSurveys">
                  <template #title> Par Formulaire</template>
                  <template #default>
                    <div v-if="surveys.length > 0" class="d-flex flex-wrap p-5">
                      <b-tabs>
                        <b-tab v-for="cat in branchCategories" :key="cat.uuid">
                          <template #title>
                            {{ cat.label }}
                          </template>
                          <template #default>
                            <div class="p-5">
                              <b-tabs>
                                <b-tab v-for="branch in cat.branches" :key="branch.uuid">
                                  <template #title>
                                    {{ branch.label }}
                                  </template>
                                  <template #default>
                                    <div class="p-5">
                                      <template v-if="
                                        surveyGroupByBranch.hasOwnProperty(
                                          branch.slug
                                        )
                                      ">
                                        <table
                                          class="table g-2 table-head-custom table-head-bg table-borderless table-vertical-center table-hover table-striped">
                                          <thead>
                                            <tr>
                                              <th>Formulaire</th>
                                              <th>Lien public</th>
                                              <th>Accès personnalisé</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="survey in surveyGroupByBranch[
                                              branch.slug
                                            ]" :key="survey.slug">
                                              <td>
                                                {{ survey.label }}
                                              </td>
                                              <td :set="(url = getUrl({
                                                name: 'response-group-manager',
                                                params: {
                                                  surveySlug: survey.slug,
                                                  rgUuid: 'new',
                                                },
                                                query: {
                                                  source: partner.code,
                                                },
                                              }))
                                                ">
                                                <div v-if="generatedLinks.surveys[survey.slug]" class="mb-2">
                                                  <a :href="generatedLinks.surveys[survey.slug]" target="_blank"
                                                    class="fw-bolder">
                                                    {{ generatedLinks.surveys[survey.slug] }}
                                                  </a>
                                                  <button class="btn btn-sm btn-icon btn-light-primary ms-2"
                                                    @click="copyToClipboard(generatedLinks.surveys[survey.slug])"
                                                    v-b-tooltip.hover title="Copier le lien">
                                                    <i class="fad fa-copy"></i>
                                                  </button>
                                                </div>
                                                <b-dropdown btnClass="btn-icon" no-caret size="sm"
                                                  toggle-class="btn-icon" variant="primary">
                                                  <template v-slot:button-content>
                                                    <i class="fad fa-qrcode"></i>
                                                  </template>
                                                  <b-dropdown-text class="w-300px" tag="div">
                                                    <a :href="generatedLinks.surveys[survey.slug] || url"
                                                      class="text-center d-flex justify-content-center" target="_blank">
                                                      <vue-qr :autoColor="true" :qid="survey.uuid" :size="300"
                                                        :text="generatedLinks.surveys[survey.slug] || url"
                                                        :whiteMargin="true" class="rounded position-relative"
                                                        colorDark="black" colorLight="white"></vue-qr>
                                                    </a>
                                                  </b-dropdown-text>
                                                </b-dropdown>
                                              </td>
                                              <td></td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </template>
                                    </div>
                                  </template>
                                </b-tab>
                              </b-tabs>
                            </div>
                          </template>
                        </b-tab>
                      </b-tabs>
                    </div>
                    <Loading v-else />
                  </template>
                </b-tab>
                <b-tab>
                  <template #title> Par Whatsapp</template>
                  <template #default>
                    <div class="p-5">
                      <div class="bg-light-primary d-flex flex-wrap">
                        <div :set="(url = getWhaUrl(null))" class="position-relative m-10 p-5 rounded"
                          style="background: #e0338a">
                          <b-form-input id="input-1" v-model="message" class="my-2" placeholder="Entrez un message"
                            type="text" />

                          <!-- Lien minifié si disponible -->
                          <div v-if="generatedLinks.whatsapp.global" class="mb-3 text-center bg-white rounded p-3">
                            <div class="badge badge-success fs-6 p-3 mb-2">
                              <i class="fad fa-check-circle me-2"></i>
                              Lien court généré
                            </div>
                            <div class="mt-2">
                              <a :href="generatedLinks.whatsapp.global" target="_blank" class="fw-bolder">
                                {{ generatedLinks.whatsapp.global }}
                              </a>
                              <button class="btn btn-sm btn-icon btn-light-primary ms-2"
                                @click="copyToClipboard(generatedLinks.whatsapp.global)" v-b-tooltip.hover
                                title="Copier le lien">
                                <i class="fad fa-copy"></i>
                              </button>
                            </div>
                          </div>

                          <a :href="generatedLinks.whatsapp.global || url"
                            class="text-center d-flex justify-content-center" target="_blank">
                            <vue-qr :autoColor="true" :size="300" :text="generatedLinks.whatsapp.global || url"
                              :whiteMargin="true" class="rounded position-relative" colorDark="black"
                              colorLight="white"></vue-qr>
                          </a>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-tab>
                <b-tab>
                  <template #title> Par Agent</template>
                  <template #default>
                    <div class="p-5">
                      <div class="d-flex justify-content-end" @click="printUserQrCodes">
                        <div class="btn btn-warning">
                          <i class="fad fa-print"></i>
                          Imprimer
                        </div>
                      </div>
                      <div class="my-10">
                        <b-form-input id="input-1" v-model="message" class="my-2" placeholder="Entrez un message"
                          type="text" />
                      </div>
                      <div id="user-qr-codes-container" class="printable" style="
                            display: flex;
                            flex-wrap: wrap;
                            justify-content: center;
                            align-items: flex-start;
                          ">
                        <template v-for="partner in users">
                          <div :key="partner.code" :set="(url = getWhaUrl(partner))" class="qr-code" style="
                                position: relative;
                                padding: 0;
                                border-radius: 10px;
                                background: white;
                                border: 1px whitesmoke solid;
                                break-inside: avoid;
                                margin: 10px;
                              ">
                            <img alt="" src="../../../assets/illustrations/rectangle.svg" style="width: 100%" />
                            <div class="content-qr" style="
                                  display: flex;
                                  position: relative;
                                  align-items: center;
                                  justify-content: center;
                                  padding: 20px 20px;
                                  border-bottom: 1px whitesmoke solid;
                                ">
                              <a :href="generatedLinks.whatsapp.agents[partner.code] || url"
                                class="d-flex justify-content-center position-relative" target="_blank">
                                <vue-qr :autoColor="true" :size="400"
                                  :text="generatedLinks.whatsapp.agents[partner.code] || url" :whiteMargin="true"
                                  class="rounded position-relative" colorDark="black" colorLight="white"
                                  style="width: 400px; height: 400px"></vue-qr>
                                <div style="
                                      position: absolute;
                                      left: -5px;
                                      top: -5px;
                                      width: 80px;
                                      height: 80px;
                                      border-top: 10px black solid;
                                      border-left: 10px black solid;
                                      border-radius: 10px;
                                    "></div>
                                <div style="
                                      position: absolute;
                                      right: -5px;
                                      top: -5px;
                                      width: 80px;
                                      height: 80px;
                                      border-top: 10px black solid;
                                      border-right: 10px black solid;
                                      border-radius: 10px;
                                    "></div>
                                <div style="
                                      position: absolute;
                                      right: -5px;
                                      bottom: -5px;
                                      width: 80px;
                                      height: 80px;
                                      border-bottom: 10px black solid;
                                      border-right: 10px black solid;
                                      border-radius: 10px;
                                    "></div>
                                <div style="
                                      position: absolute;
                                      left: -5px;
                                      bottom: -5px;
                                      width: 80px;
                                      height: 80px;
                                      border-bottom: 10px black solid;
                                      border-left: 10px black solid;
                                      border-radius: 10px;
                                    "></div>
                              </a>
                            </div>
                            <div class="uppercase d-flex justify-content-center flex-column p-5 W-100 text-center"
                              style="color: #128997">
                              <div class="fw-bolder fs-2">
                                {{ partner.name }} |
                                {{
                                  shortener
                                    .converIdToCHar(partner.id)
                                    .toUpperCase()
                                }}
                              </div>
                              <div class="fs-2">COMMERCIAL</div>

                              <!-- Lien court si disponible -->
                              <div v-if="generatedLinks.whatsapp.agents[partner.code]"
                                class="mt-3 bg-light rounded p-2">
                                <div class="badge badge-success mb-1">
                                  <i class="fad fa-link me-1"></i>
                                  Lien court
                                </div>
                                <div class="fs-7 text-break">
                                  {{ generatedLinks.whatsapp.agents[partner.code] }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </b-tab>
              </b-tabs>
            </div>
          </b-tab>


          <b-tab :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'" @click="loadUsers">
            <template #title>
              <div class="d-flex align-items-center">
                <i class="fad fa-users fs-2 me-2"></i>
                {{ trans("Utilisateurs") }}
              </div>
            </template>
            <div>
              <div class="d-flex justify-content-end">
                <div class="btn btn-primary" @click="createUser">
                  <i class="fad fa-plus"></i>
                  Créer
                </div>
              </div>
              <Loading v-if="loadingUsers" />
              <table class="table table-striped gy-3 gs-3">
                <thead>
                  <tr class="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200">
                    <th>Utilisateur</th>
                    <th>Code</th>
                    <th>Email</th>
                    <th>Contact</th>
                    <th>Agence</th>
                    <th>Créer le</th>
                    <th>Dernière authentification</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="partner in users">
                    <tr :key="'p_' + partner.uuid" style="height: 1px">
                      <td>
                        {{ partner.name }}
                      </td>
                      <td>
                        {{ partner.code }}
                      </td>
                      <td>
                        {{ partner.email }}
                      </td>
                      <td>
                        {{ partner.contact }}
                      </td>
                      <td>
                        {{ getAgencyNameByCode(partner.agency) }}
                      </td>
                      <td>
                        {{ readableDate(partner.createdAt, "dmY H:i") }}
                      </td>
                      <td>
                        {{ readableDate(partner.lastToken, "dmY H:i") }}
                      </td>

                      <td class="text-end">
                        <div class="d-flex justify-content-end">
                          <div class="btn btn-xs btn-icon btn-primary m-1" @click="editUser(partner)">
                            <i class="fad fa-edit"></i>
                          </div>
                          <div class="btn btn-xs btn-icon btn-danger m-1" @click="deleteUser(partner.code)">
                            <i class="fad fa-ban"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab v-if="hasRole('ROLE_MANAGER')" :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'"
            @click="initCommission">
            <template #title>
              <div class="d-flex align-items-center">
                <i class="fad fa-file-contract fs-2 me-2"></i>
                Commissions
              </div>
            </template>
            <div>
              <b-tabs>
                <b-tab v-for="category in branchCategories" :key="'cat_' + category.uuid">
                  <template #title>
                    <div class="d-flex align-items-center">
                      {{ category.label }}
                    </div>
                  </template>

                  <div>
                    <b-tabs class="p-5">
                      <b-tab v-for="branch in category.branches" :key="branch.uuid" @click="loadMethods(branch)">
                        <template #title>
                          <div class="d-flex align-items-center">
                            {{ branch.label }}
                          </div>
                        </template>

                        <div class="card">
                          <div class="card-body">
                            <h3>
                              {{
                                trans("Selectionnez une methode de calcul")
                              }}
                            </h3>
                            <Loading v-if="loadingEngineMethod" />
                            <!--                            <div class="d-flex" v-else>-->
                            <!--                              <div>-->
                            <!--                                <select class="form-select">-->
                            <!--                                  <option value="" v-for="method in engineMethods" :key="'method_' + method.id">-->
                            <!--                                    {{ method.insurer ? method.insurer.label : 'GLOBAL' }} - {{ method.label }}-->
                            <!--                                  </option>-->
                            <!--                                </select>-->
                            <!--                              </div>-->
                            <!--                              <div class="btn btn-primary btn-icon ms-5">-->
                            <!--                                <i class="fad fa-plus"></i>-->
                            <!--                              </div>-->
                            <!--                            </div>-->
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </b-tab>
          <b-tab v-if="hasRole('ROLE_MANAGER')" :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'" @click="ensurePaymentsLoaded">
            <template #title>
              <div class="d-flex align-items-center">
                <i class="fad fa-coins fs-2 me-2"></i>
                Paiements
              </div>
            </template>
            <div class="p-3">
              <!-- Filtres -->
              <div class="row g-3 mb-4 align-items-end">
                <div class="col-md-4">
                  <label class="form-label small text-gray-600">Recherche</label>
                  <input v-model="paymentSearch.contains" type="text" class="form-control form-control-sm"
                         placeholder="Police, n° contrat, client, mobile, uuid, initiateur..."
                         @keyup.enter="reloadPayments()">
                </div>
                <div class="col-md-2">
                  <label class="form-label small text-gray-600">Statut</label>
                  <select v-model="paymentSearch.status" class="form-control form-control-sm form-select" @change="reloadPayments()">
                    <option :value="''">Tous</option>
                    <option value="SUCCEED">Réussi</option>
                    <option value="PENDING">En attente</option>
                    <option value="FAILED">Échoué</option>
                    <option value="CANCELLED">Annulé</option>
                    <option value="EXPIRED">Expiré</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label small text-gray-600">Du</label>
                  <input v-model="paymentSearch.start" type="date" class="form-control form-control-sm" @change="reloadPayments()">
                </div>
                <div class="col-md-2">
                  <label class="form-label small text-gray-600">Au</label>
                  <input v-model="paymentSearch.end" type="date" class="form-control form-control-sm" @change="reloadPayments()">
                </div>
                <div class="col-md-1">
                  <label class="form-label small text-gray-600">Min</label>
                  <input v-model.number="paymentSearch.minPrice" type="number" class="form-control form-control-sm" @change="reloadPayments()">
                </div>
                <div class="col-md-1">
                  <label class="form-label small text-gray-600">Max</label>
                  <input v-model.number="paymentSearch.maxPrice" type="number" class="form-control form-control-sm" @change="reloadPayments()">
                </div>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <button class="btn btn-sm btn-light-primary" @click="reloadPayments()">
                  <i class="fad fa-search me-1"></i>Rechercher
                </button>
                <button class="btn btn-sm btn-light-secondary" @click="resetPaymentSearch()">
                  <i class="fad fa-rotate-left me-1"></i>Réinitialiser
                </button>
              </div>

              <Pagination v-if="paymentsTotal > 0"
                          :value="paymentsPage"
                          :match-count="paymentsTotal"
                          :item-length="payments.length"
                          :per-page="paymentsPerPage"
                          :show-empty="false"
                          @input="onPaymentPageChange" />

              <div v-if="paymentsLoading" class="text-center py-5">
                <i class="fad fa-spinner fa-spin fs-1"></i>
              </div>
              <div v-else-if="payments.length === 0" class="text-center text-muted py-5">
                Aucun paiement trouvé pour ce partenaire.
              </div>
              <div v-else class="table-responsive">
                <table class="table table-striped gy-3 gs-3">
                  <thead>
                    <tr class="fw-bolder fs-7 text-gray-800 border-bottom border-gray-200">
                      <th>Date</th>
                      <th>Contrat / Client</th>
                      <th>Initiateur</th>
                      <th>Méthode</th>
                      <th class="text-end">Montant</th>
                      <th>Statut</th>
                      <th class="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="p in payments" :key="p.id" class="fs-7">
                      <td>
                        <div>{{ readableDate(p.createdAt, 'dmy') }}</div>
                        <div class="text-muted fs-8">{{ readableDate(p.createdAt, 'h:m') }}</div>
                      </td>
                      <td>
                        <div class="fw-bolder">
                          {{ p.avenant?.contract?.police || p.avenant?.contract?.number || p.label || '—' }}
                        </div>
                        <div class="text-muted fs-8" v-if="p.avenant?.contract?.subscriber">
                          {{ p.avenant.contract.subscriber.prename }} {{ p.avenant.contract.subscriber.name }}
                          <span v-if="p.avenant.contract.subscriber.mobile" class="ms-2">{{ p.avenant.contract.subscriber.mobile }}</span>
                        </div>
                      </td>
                      <td>{{ p.initiator || '—' }}</td>
                      <td>{{ p.method?.label || p.method?.slug || '—' }}</td>
                      <td class="text-end fw-bolder">{{ helper.currencyFormat(p.amount) }}</td>
                      <td>
                        <span class="badge"
                              :class="{
                                'badge-light-success': p.status === 'SUCCEED',
                                'badge-light-warning': p.status === 'PENDING',
                                'badge-light-danger': p.status === 'FAILED' || p.status === 'CANCELLED' || p.status === 'EXPIRED',
                              }">
                          {{ p.status }}
                        </span>
                      </td>
                      <td class="text-end">
                        <a v-if="p.status === 'SUCCEED'"
                           :href="coreEndpoint + 'payment/receipt/' + p.uuid"
                           target="_blank"
                           class="btn btn-icon btn-xs btn-light-primary"
                           v-b-tooltip.hover title="Télécharger le reçu">
                          <i class="fad fa-receipt"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <Pagination v-if="paymentsTotal > 0"
                          :value="paymentsPage"
                          :match-count="paymentsTotal"
                          :item-length="payments.length"
                          :per-page="paymentsPerPage"
                          :show-empty="false"
                          @input="onPaymentPageChange" />
            </div>
          </b-tab>
          <b-tab v-if="hasRole('ROLE_MANAGER')" :title-link-class="'nav-link text-active-primary me-6 pt-2 pb-5'">
            <template #title>
              <div class="d-flex align-items-center">
                <i class="fad fa-shield-check fs-2 me-2"></i>
                {{ trans("Restrictions") }}
              </div>
            </template>
            <div class="p-5">
              <PartnerRestrictionTabs v-if="partner" :code="partner.code" />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <!-- Modal de création de lien personnalisé -->
    <b-modal id="createCustomLink" ref="createCustomLink" title="Créer un lien personnalisé" centered size="xl">
      <form>
        <div class="row g-3">
          <!-- Plateforme -->
          <div class="col-md-6">
            <label class="required form-label">Plateforme</label>
            <select v-model="link.platform" class="form-control form-select" @change="onPlatformChange">
              <option :value="null">Sélectionnez une plateforme</option>
              <option v-for="platform in platforms" :key="platform.code" :value="platform.code">
                {{ platform.name }}
              </option>
            </select>
          </div>

          <!-- Formulaire (seulement si Backend ou Comparateur) -->
          <div class="col-md-6" v-if="link.platform && link.platform !== 'WHATSAPP'">
            <label class="form-label">Formulaire</label>
            <select v-model="link.survey" class="form-control form-select">
              <option :value="null">Tous les formulaires</option>
              <option v-for="survey in surveys" :key="survey.slug" :value="survey.slug">
                {{ survey.label }}
              </option>
            </select>
          </div>

          <!-- Message WhatsApp (seulement si WhatsApp) -->
          <div class="col-12" v-if="link.platform === 'WHATSAPP'">
            <label class="required form-label">Message WhatsApp</label>
            <textarea v-model="link.whatsappMessage" class="form-control" rows="3"
              placeholder="Entrez le message qui sera envoyé avec le lien"></textarea>
            <small class="text-muted">
              Le code partenaire sera automatiquement ajouté au message : ❖{{ $route.params.code }}❖
            </small>
          </div>

          <!-- Agents -->
          <div class="col-md-6">
            <label class="form-label">Agent(s)</label>
            <b-dropdown class="w-100" no-caret variant="outline-secondary">
              <template v-slot:button-content>
                <div class="d-flex justify-content-between align-items-center w-100">
                  <template v-if="empty(link.agents)">
                    Sélectionnez des agents
                  </template>
                  <template v-else>
                    <div class="d-flex flex-wrap gap-1">
                      <span v-for="(agent, index) in link.agents" :key="index" class="badge bg-primary">
                        {{ getPartnerUserDisplay(agent) }}
                        <i class="fad fa-times ms-1 cursor-pointer" @click.stop="togglePartner(agent)"></i>
                      </span>
                    </div>
                  </template>
                  <i class="fad fa-angle-down"></i>
                </div>
              </template>
              <b-dropdown-text class="p-0" style="min-width: 300px">
                <div class="p-2">
                  <input v-model="partnerSearched" class="form-control form-control-sm mb-2" placeholder="Rechercher..."
                    type="text" />
                </div>
                <div style="max-height: 250px; overflow-y: auto">
                  <template v-for="(user, index) of users">
                    <div v-if="
                      empty(partnerSearched) ||
                      (!empty(user.name) &&
                        user.name.toLowerCase().includes(partnerSearched.toLowerCase())) ||
                      user.code.toLowerCase().includes(partnerSearched.toLowerCase())
                    " :key="index" :class="{
                          'bg-light': link.agents.some(
                            (a) => a.code === user.code && a.email === user.email
                          ),
                        }" class="px-3 py-2 cursor-pointer hover-bg-light" @click="togglePartner(user)">
                      <div class="fw-bold">{{ user.name }}</div>
                      <div class="text-muted small">{{ user.code }}</div>
                    </div>
                  </template>
                </div>
              </b-dropdown-text>
            </b-dropdown>
          </div>

          <!-- Date d'expiration -->
          <div class="col-md-6">
            <label class="form-label">Date d'expiration</label>
            <input v-model="link.expireAt" class="form-control" type="date" />
          </div>

          <!-- Accès personnalisé -->
          <div class="col-md-12">
            <label class="form-label">Accès personnalisé (Rôle)</label>
            <select v-model="link.role" class="form-control form-select">
              <option :value="null">Aucun rôle spécifique</option>
              <option v-for="role in roles" :key="role.code" :value="role.code">
                {{ role.label }}
              </option>
            </select>
          </div>
        </div>
      </form>
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          <i class="fad fa-times"></i>
          Annuler
        </b-button>
        <b-button size="sm" variant="primary" @click="generateLink" :disabled="!link.platform">
          <i class="fad fa-link"></i>
          Générer le lien
        </b-button>
      </template>
    </b-modal>

    <b-modal id="editPartner" ref="editPartner" :title="trans('Créer un partenaire')" centered>
      <form>
        <div v-if="partner" class="row">
          <div class="col-auto m-2 flex-grow-1">
            <label :for="'label'" class="required form-label">{{
              trans("Label")
            }}</label>
            <b-form-input :id="'label'" v-model="partner.name" :state="!helper.empty(partner.name)">
            </b-form-input>
          </div>

          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Code")
            }}</label>
            <b-form-input :id="'code'" v-model="partner.code" v-uppercase :state="!helper.empty(partner.code)">
            </b-form-input>
          </div>

          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Contact")
            }}</label>
            <b-form-input :id="'code'" v-model="partner.contact" :state="!helper.empty(partner.contact)">
            </b-form-input>
          </div>
          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Methode de paiement autorisée")
            }}</label>
            <div class="d-flex flex-wrap justify-content-between">
              <div v-for="method in methods" :key="'m_' + method.id" class="m-2 fw-bolder d-flex align-items-center">
                <label class="form-check form-switch form-check-custom form-check-solid m-2">
                  <input :checked="isMethodActiveForPartner(method, partner)" class="form-check-input" type="checkbox"
                    @change="toggleMethodForPartner(method, partner)" />
                </label>
                {{ method.label }}
              </div>
            </div>
          </div>
        </div>
      </form>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          <i class="fad fa-times"></i>
          {{ trans("Cancel") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="savePartner">
          <i class="fad fa-save"></i>
          {{ trans("Save") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="editAgency" ref="editAgency" :title="trans('Créer une agence')" centered>
      <form>
        <div v-if="agency && partner" class="row">
          <div class="col-auto m-2 flex-grow-1">
            <label :for="'label'" class="required form-label">{{
              trans("Nom")
            }}</label>
            <b-form-input :id="'label'" v-model="agency.name" :state="!helper.empty(agency.name)">
            </b-form-input>
          </div>

          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Code")
            }}</label>
            <b-input-group>
              <template #prepend>
                <b-input-group-text class="bg-light-primary"><strong class="text-primary fw-bolder">{{ partner.code
                    }}-</strong></b-input-group-text>
              </template>
              <b-form-input :id="'code'" v-model="agency.code" v-uppercase :state="!helper.empty(agency.code)">
              </b-form-input>
            </b-input-group>
          </div>

          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Contact")
            }}</label>
            <b-form-input :id="'code'" v-model="agency.contact" :state="!helper.empty(agency.contact)">
            </b-form-input>
          </div>
          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Methode de paiement autorisée")
            }}</label>
            <div class="d-flex flex-wrap justify-content-between">
              <div v-for="method in methods" :key="'me_' + method.id" class="m-2 fw-bolder d-flex align-items-center">
                <label class="form-check form-switch form-check-custom form-check-solid m-2">
                  <input :checked="isMethodActiveForPartner(method, agency)" class="form-check-input" type="checkbox"
                    @change="toggleMethodForPartner(method, agency)" />
                </label>
                {{ method.label }}
              </div>
            </div>
          </div>
        </div>
      </form>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          <i class="fad fa-times"></i>
          {{ trans("Cancel") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="saveAgency">
          <i class="fad fa-save"></i>
          {{ trans("Save") }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="editUser" ref="editUser" :title="trans('Utilisateurs')" centered>
      <form>
        <div v-if="user && partner" class="row">
          <div class="col-auto m-2 flex-grow-1">
            <label :for="'label'" class="required form-label">{{
              trans("Noms")
            }}</label>
            <b-form-input :id="'label'" v-model="user.name" :state="!helper.empty(user.name)">
            </b-form-input>
          </div>

          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Email")
            }}</label>
            <b-form-input :id="'code'" v-model="user.email" :state="!helper.empty(user.email)">
            </b-form-input>
          </div>
          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Agence")
            }}</label>
            <select v-model="user.agency" class="form-control form-select">
              <option :value="partner.code">{{ partner.name }}</option>
              <option v-for="agency in partner.agencies" :key="'ag_' + agency.uuid" :value="agency.code">
                {{ agency.name }}
              </option>
            </select>
          </div>
          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Mot de passe")
            }}</label>
            <b-form-input :id="'code'" v-model="user.password" :state="!helper.empty(user.password)">
            </b-form-input>
          </div>
          <div class="col-auto m-2 flex-grow-1">
            <label :for="'code'" class="required form-label">{{
              trans("Contact")
            }}</label>
            <b-form-input :id="'code'" v-model="user.contact" :state="!helper.empty(user.contact)">
            </b-form-input>

            <div class="form-check form-switch form-check-custom form-check-solid mt-5 d-flex align-items-center">
              <label :for="'code'" class="required form-label me-5">{{
                trans("Administrateur de l'agence")
              }}</label>
              <input @change="setUserAdmin($event.target.checked)" class="form-check-input h-30px w-50px"
                type="checkbox" :checked="verifyRoles(user)" />
            </div>
          </div>

          <!--            <div class="col-auto m-2 flex-grow-1">-->
          <!--              <label :for="'code'" class="required form-label">{{ trans('Tenant autorisé') }}</label>-->
          <!--              <div class="row">-->
          <!--                <div class="col" v-for="(tenant, index) in tenants" :key="index">-->
          <!--                  <div class="col-auto m-2 flex-grow-1">-->
          <!--                    <label class="form-check form-switch form-check-custom form-check-solid">-->
          <!--                      <input class="form-check-input" type="checkbox"-->
          <!--                        v-model="user.roles" :value="'ROLE_PARTNER_'+helper.upperCase(tenant.code)"/>-->
          <!--                      <span class="form-check-label">-->
          <!--                        {{ trans(tenant.label) }}-->
          <!--                      </span>-->
          <!--                    </label>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
      </form>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          <i class="fad fa-times"></i>
          {{ trans("Cancel") }}
        </b-button>
        <b-button size="sm" variant="primary" @click="updatePartnerUser">
          <i class="fad fa-save"></i>
          {{ trans("Save") }}
        </b-button>
      </template>
    </b-modal>
  </template>
  </Base>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import Contract from "@/entity/Contract";
import { api } from "@/services/Api";
import Loading from "@/components/Loading.vue";
import FileUpload from "@/components/FileUpload.vue";
import UserView from "@/components/UserView.vue";
import IncorporationDetail from "@/views/Contract/IncorporationDetail.vue";
import Swal from "sweetalert2";
import Partner from "@/entity/Partner";
import PaymentMethod from "@/entity/PaymentMethod";
import BranchCategory from "@/entity/BranchCategory";
import Branch from "@/entity/Branch";
import EngineMethod from "@/entity/EngineMethod";
import { helper } from "@/services/Helper";
import PartnerTree from "@/views/Partner/PartnerTree.vue";
import Survey from "@/entity/Survey";
import VueQr from "vue-qr";
import Tenant from "@/entity/Tenant";
import Role from "@/entity/Role";
import { shortener } from "@/Utils/Shortener";
import { auth } from "@/services/Auth";
import PartnerLink from "@/entity/PartnerLink";
import Pagination from "@/components/Pagination.vue";
import RoleLine from "@/views/Role/RoleLine.vue";

@Component({
  components: {
    PartnerTree,
    IncorporationDetail,
    FileUpload,
    Loading,
    Base,
    UserView,
    VueQr,
    Pagination,
    RoleLine,
    PartnerRestrictionTabs: () => import("@/views/Income/Partner/PartnerRestrictionTabs.vue"),
  },
})
export default class PartnerForm extends Vue {
  partnerSearched = "";
  filterSurveySearch = "";
  filterAgentSearch = "";
  shortener = shortener;
  helper = helper;
  amount = 0;
  comparatorUrl = api.comparator;
  coreEndpoint = api.core;
  uploadRoot = api.uploadRoot;
  tabIndex = 0;
  isLoading = false;
  avenant: any = null;
  contracts: Contract[] = [];
  methods: PaymentMethod[] = [];
  paymentMethods: PaymentMethod[] = [];
  partner: Partner | any = null;
  user: Partner = new Partner();
  agency: Partner = new Partner();
  branchCategories: BranchCategory[] = [];
  surveyOf: any = null;
  searchAgency = "";
  // categories: BranchCategory[] = []
  surveys: Survey[] = [];
  tenants: Tenant[] = [];
  // branches: Branch[] = []
  roleByTenants: string[] = [];
  message = "Bonjour j'ai été approché par un apporteur.";
  platforms = [
    { name: "Back Office", code: "BACKEND", baseUrl: "" },
    { name: "Comparateur", code: "COMPARATOR", baseUrl: "" },
    { name: "WhatsApp", code: "WHATSAPP", baseUrl: "" },
  ];
  link: any = {
    partner: this.$route.params.code,
    platform: null,
    survey: null,
    agents: [],
    expireAt: null,
    role: null,
    whatsappMessage: "Bonjour j'ai été approché par un apporteur.", // Message pour WhatsApp
  };
  roles: any[] = [];
  links: any[] = [];
  loadingContracts = false;
  contractPage = 1;
  users: Partner[] = [];
  loadingUsers = false;
  agencies: Partner[] = [];
  engineMethods: EngineMethod[] = [];
  loadingEngineMethod = false;

  total = 0;
  matchCount = 0;
  search = {
    page: 1,
    max: 10,
    platform: null,
    survey: null,
    agent: null,
  };

  // ====== Onglet Paiements ======
  payments: any[] = [];
  paymentsTotal = 0;
  paymentsPage = 1;
  paymentsPerPage = 25;
  paymentsLoading = false;
  paymentsLoaded = false;
  paymentSearch: any = {
    contains: "",
    status: "",
    start: "",
    end: "",
    minPrice: null,
    maxPrice: null,
  };

  // Structure pour stocker les liens minifiés
  generatedLinks: any = {
    platform: {
      backoffice: null,
      comparator: null,
    },
    surveys: {}, // { surveySlug: shortUrl }
    whatsapp: {
      global: null,
      agents: {}, // { agentCode: shortUrl }
    },
  };
  isGeneratingLinks = false;

  get surveyGroupByBranch() {
    const grouped: any = {};
    for (const item of this.surveys) {
      const key = item.branch || "autres";
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    }
    return grouped;
  }

  setUserAdmin(value: boolean) {
    if (
      this.user &&
      this.user.roles &&
      !this.user.roles.includes("ROLE_ADMIN-PARTNER") &&
      value
    ) {
      this.user.roles.push("ROLE_ADMIN-PARTNER");
    }
  }

  verifyRoles(user: Partner) {
    return user.roles.includes("ROLE_ADMIN-PARTNER");
  }

  printUserQrCodes() {
    const container: any = document.querySelector("#user-qr-codes-container");
    const els: any = document.querySelectorAll("body>*");
    els.forEach((el: any) => {
      el.classList.add("print-hide");
    });
    const clone = container.cloneNode(true);
    clone.id = "qr-clone";
    clone.style.position = "absolute";
    // container.style.overflow = 'auto'
    clone.style.top = 0;
    clone.style.left = 0;
    clone.style.width = "100%";
    clone.style.height = "100%";
    clone.style.zIndex = 9999;
    document.body.appendChild(clone);
    window.print();

    els.forEach((el: any) => {
      el.classList.remove("print-hide");
    });
    document.body.removeChild(clone);
  }

  loadLinkData() {
    this.loadUsers();
    this.loadSurveys();
    this.loadLinkList();
  }

  getUrl(data: any) {
    const url = window.location.origin + this.$router.resolve(data).href;
    return url;
  }

  getPartnerUserDisplay(agent: { code: string; email: string }) {
    if (agent.code === "all") {
      return "Tous les partenaires";
    }
    const partner = this.users.find((partner: Partner) => {
      return partner.code === agent.code && partner.email === agent.email;
    });
    if (partner) {
      if (!helper.empty(partner.name)) {
        return `${partner.name}`;
      }
      return `${partner.code}`;
    }
    return `${agent.code}`;
  }

  getUrlPlatform(data: any) {
    const url = window.location.origin + this.$router.resolve(data).href;
    return url;
  }

  getUrlComparator(data: any) {
    const url = process.env.VUE_APP_COMPARATOR_URL + "?source=" + data;
    return url;
  }

  async loadHierarchy() {
    // const res = await api.get(api.auth, "role/list");
    const res = await api.get(api.auth, "role/list");
    if (res && res.data && res.data.role) {
      this.roles = [];
      const occ = new Role(res.data.role);
      this.roles.push(occ);
    }
  }

  async loadLinkList() {
    if (this.search.page) {
      if (!isNaN(this.search.page!)) {
        this.search.page = parseInt(this.search.page + "");
      }
    }
    const res = await api.get(
      api.core,
      "partner/link/list/" + this.$route.params.code,
      {
        params: this.search,
      }
    );
    if (res && res.data && res.data.links) {
      this.links = res.data.links;
    }
    this.total = res.data.total;
    this.matchCount = res.data.total;
  }

  // Alias pour loadLinkList
  loadLinks() {
    this.search.page = 1; // Reset to first page when filtering
    this.loadLinkList();
  }

  // Réinitialiser les filtres
  resetFilters() {
    this.search.platform = null;
    this.search.survey = null;
    this.search.agent = null;
    this.search.page = 1;
    this.loadLinkList();
  }

  // Gère le changement de plateforme
  onPlatformChange() {
    // Réinitialise le formulaire selon la plateforme
    if (this.link.platform === "WHATSAPP") {
      this.link.survey = null;
    }
  }

  async generateLink() {
    if (!helper.empty(this.link.platform)) {
      const generate = await Swal.fire({
        title: "Confirmer",
        icon: "question",
        html: "Êtes-vous sûr de vouloir générer ce lien ?",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "Générer",
        cancelButtonText: "Annuler",
      });
      if (generate.isConfirmed) {
        this.$store.commit("loading");

        // Pour WhatsApp, construire l'URL avec le message
        if (this.link.platform === "WHATSAPP") {
          const whatsappUrl = this.getWhaUrlWithMessage(
            this.link.agents.length > 0 ? this.link.agents[0] : null,
            this.link.whatsappMessage
          );

          // Générer le lien court pour WhatsApp
          await api.post(api.core, "partner/generate/custom/link", {
            ...this.link,
            customUrl: whatsappUrl,
          });
        } else {
          // Pour Backend et Comparateur
          await api.post(api.core, "partner/generate/custom/link", this.link);
        }

        this.$store.commit("stopLoading");
        this.loadLinkList();
        (this.$refs as any).createCustomLink.hide();

        // Réinitialiser le formulaire
        this.link = {
          partner: this.$route.params.code,
          platform: null,
          survey: null,
          agents: [],
          expireAt: null,
          role: null,
          whatsappMessage: "Bonjour j'ai été approché par un apporteur.",
        };
      }
    }
  }

  // Génère un lien court pour une URL donnée
  async generateShortLink(fullUrl: string, type: string, reference: string) {
    try {
      // Déterminer la plateforme selon le type
      let platform = "CUSTOM";
      let survey = null;

      if (type.startsWith("WHATSAPP_")) {
        platform = "WHATSAPP";
      } else if (type === "PLATFORM_BACKOFFICE") {
        platform = "BACKEND";
      } else if (type === "PLATFORM_COMPARATOR") {
        platform = "COMPARATOR";
      } else if (type === "SURVEY") {
        platform = "BACKEND";
        survey = reference; // Le slug du formulaire
      }

      const res = await api.post(api.core, "partner/generate/custom/link", {
        partner: this.$route.params.code,
        platform: platform,
        survey: survey,
        agents: [],
        expireAt: null,
        role: null,
        customUrl: fullUrl,
        type: type,
        reference: reference,
      });

      if (res && res.data && res.data.link && res.data.link.short) {
        return res.data.link.short;
      }
      return fullUrl; // Retourne l'URL complète si la minification échoue
    } catch (error) {
      console.error("Erreur lors de la génération du lien court:", error);
      return fullUrl;
    }
  }

  // Génère tous les liens courts
  // Copie un lien dans le presse-papiers
  async copyToClipboard(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      this.$store.commit("pushNotification", {
        type: "success",
        message: "Lien copié dans le presse-papiers !",
        timeout: 2000,
      });
    } catch (error) {
      console.error("Erreur lors de la copie:", error);
      this.$store.commit("pushNotification", {
        type: "error",
        message: "Impossible de copier le lien",
        timeout: 2000,
      });
    }
  }

  async generateAllShortLinks() {
    const confirm = await Swal.fire({
      title: "Générer tous les liens courts",
      icon: "question",
      html: "Voulez-vous générer les liens minifiés pour tous les liens (Plateformes, Formulaires, WhatsApp, Agents) ?",
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Générer",
      cancelButtonText: "Annuler",
    });

    if (!confirm.isConfirmed) {
      return;
    }

    this.isGeneratingLinks = true;
    this.$store.commit("loading", "Génération des liens courts en cours...");

    try {
      let totalGenerated = 0;

      // 1. Liens Plateforme
      if (this.partner) {
        // Backoffice
        const backofficeUrl = this.getUrlPlatform({
          name: "comparateur-index",
          query: { source: this.partner.code },
        });
        this.generatedLinks.platform.backoffice = await this.generateShortLink(
          backofficeUrl,
          "PLATFORM_BACKOFFICE",
          this.partner.code
        );
        totalGenerated++;

        // Comparateur
        const comparatorUrl = this.getUrlComparator(this.partner.code);
        this.generatedLinks.platform.comparator = await this.generateShortLink(
          comparatorUrl,
          "PLATFORM_COMPARATOR",
          this.partner.code
        );
        totalGenerated++;

        // 3. Liens par Formulaire
        // for (const survey of this.surveys) {
        //   const surveyUrl = this.getUrl({
        //     name: "response-group-manager",
        //     params: {
        //       surveySlug: survey.slug,
        //       rgUuid: "new",
        //     },
        //     query: {
        //       source: this.partner.code,
        //     },
        //   });
        //   this.generatedLinks.surveys[survey.slug] =
        //     await this.generateShortLink(surveyUrl, "SURVEY", survey.slug);
        //   totalGenerated++;
        // }


      }

      this.$store.commit("stopLoading");
      this.isGeneratingLinks = false;

      await Swal.fire({
        title: "Liens générés",
        icon: "success",
        html: `${totalGenerated} liens courts ont été générés avec succès !`,
        confirmButtonText: "OK",
      });

      // Force le rafraîchissement de l'affichage
      this.$forceUpdate();
    } catch (error) {
      this.$store.commit("stopLoading");
      this.isGeneratingLinks = false;

      await Swal.fire({
        title: "Erreur",
        icon: "error",
        html: "Une erreur est survenue lors de la génération des liens courts.",
        confirmButtonText: "OK",
      });
    }
  }

  togglePartner(user: { code: string; email: string }) {
    // On cherche si l'objet existe déjà dans link.agents
    const index = this.link.agents.findIndex(
      (a: any) => a.code === user.code && a.email === user.email
    );
    if (index !== -1) {
      this.link.agents.splice(index, 1);
    } else {
      if (
        user.code === "all" ||
        this.link.agents.some((a: any) => a.code === "all")
      ) {
        this.link.agents = [{ code: "all", email: "all" }];
      } else {
        this.link.agents.push({ code: user.code, email: user.email });
      }
    }
    this.$forceUpdate();
  }

  getWhaUrl(user: any) {
    let url = null;

    if (user) {
      url =
        process.env.VUE_APP_WHATSAPP_URL +
        "?text=" +
        this.message +
        "\n\n" +
        "❖" +
        user.code +
        "❖";
      return encodeURI(url);
    } else {
      url =
        process.env.VUE_APP_WHATSAPP_URL +
        "?text=" +
        this.message +
        "\n\n" +
        "❖" +
        "" +
        this.partner.code.toUpperCase() +
        "❖";
      return encodeURI(url);
    }
  }

  // Génère une URL WhatsApp avec un message personnalisé
  getWhaUrlWithMessage(user: any, customMessage: string) {
    let url = null;
    const message = customMessage || this.message;

    if (user) {
      url =
        process.env.VUE_APP_WHATSAPP_URL +
        "?text=" +
        message +
        "\n\n" +
        "❖" +
        user.code +
        "❖";
      return encodeURI(url);
    } else {
      url =
        process.env.VUE_APP_WHATSAPP_URL +
        "?text=" +
        message +
        "\n\n" +
        "❖" +
        "" +
        this.partner.code.toUpperCase() +
        "❖";
      return encodeURI(url);
    }
  }

  async loadTenants() {
    if (this.tenants.length === 0) {
      this.$store.commit("loading");
      const res = await api.get(api.auth, "tenant/list");
      if (res && res.data && res.data.tenants) {
        this.tenants = [];
        this.roleByTenants = [];
        res.data.tenants.forEach((t: any) => {
          const occ = new Tenant(t);
          this.tenants.push(occ);
          this.roleByTenants.push("ROLE_PARTNER_" + occ.code.toUpperCase());
        });
      }
      this.$store.commit("stopLoading");
    }
  }

  getBranchLabelBySlug(slug: string) {
    for (let cat of this.branchCategories) {
      for (let branch of cat.branches) {
        if (branch.slug === slug) {
          return cat.label + " ▪️ " + branch.label;
          // return  branch.label
        }
      }
    }
    return slug;
  }

  getBranchLogoBySlug(slug: string) {
    // console.log(slug);
    for (let cat of this.branchCategories) {
      for (let branch of cat.branches) {
        if (branch.slug === slug) {
          return api.uploadRoot + branch.photo;
        }
      }
    }
    return null;
  }

  async loadSurveys() {
    const res = await api.get(api.form, "survey/get/list/for/links");
    if (res && res.data && res.data.surveys) {
      this.surveys = [];
      res.data.surveys.forEach((s: Survey) => {
        const occ = new Survey(s);
        this.surveys.push(occ);
      });
      // this.categories = [];
      // res.data.categories.forEach((c: BranchCategory) => {
      //   this.categories.push(new BranchCategory(c))
      // })
      //
      // if (!this.current && this.categories.length > 0) {
      //   this.setCurrent(this.categories[0])
      // }
    }
  }

  async updatePartnerUser() {
    // this.user.code = this.partner.code
    this.$store.commit("loading");
    const res = await api.post(api.auth, "partner/edit", {
      partner: {
        ...this.user,
        roles: Array.from(
          new Set([...(this.user.roles || []), ...(this.partner.roles || [])])
        ),
      },
    });
    this.$store.commit("stopLoading");
    (this.$refs as any).editUser.hide();
    this.loadUsers();
  }

  // createAgency() {
  //   this.agency = new Partner()
  //   this.agency.parent = this.partner
  //
  // }

  async deleteUser(code: string) {
    this.user.code = this.partner.code;

    const reset = await Swal.fire({
      title: "Suppression",
      icon: "question",
      html: "Êtes-vous sûr de vouloir supprimer ce partenaire ?",
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Supprimer",
      confirmButtonAriaLabel: "Supprimer",
      cancelButtonText: "Annuler",
      cancelButtonAriaLabel: "Annuler",
    });
    if (reset.isConfirmed) {
      this.$store.commit("loading");
      const res = await api.delete(api.auth, "partner/block/" + code);
      this.$store.commit("stopLoading");
      this.loadUsers();
    }
  }

  async mounted() {
    this.loadPartner();
    this.loadContracts();
    // this.loadUsers();
    this.loadPaymentMethods();
    // this.loadTenants();
    this.loadHierarchy();
    this.branchCategories = await this.$store.getters.branchCategories();
    // await this.loadContract()
  }

  async loadPaymentMethods() {
    // this.$store.commit('loading')
    const res = await api.get(api.core, "payment/method/list");
    if (res && res.data) {
      this.methods = [];
      res.data.methods?.forEach((p: PaymentMethod) => {
        this.methods.push(new PaymentMethod(p));
      });
    }
    // this.$store.commit('stopLoading')
  }

  async loadPayments() {
    const res = await api.get(api.core, "payment/");
  }

  ensurePaymentsLoaded() {
    if (!this.paymentsLoaded) {
      this.reloadPayments();
    }
  }

  async reloadPayments() {
    if (!this.partner?.code) return;
    this.paymentsLoading = true;
    this.paymentsLoaded = true;
    try {
      const body: any = {
        page: this.paymentsPage,
        perPage: this.paymentsPerPage,
        contains: this.paymentSearch.contains || undefined,
        start: this.paymentSearch.start || undefined,
        end: this.paymentSearch.end || undefined,
        minPrice: this.paymentSearch.minPrice ?? undefined,
        maxPrice: this.paymentSearch.maxPrice ?? undefined,
      };
      if (this.paymentSearch.status) {
        body.status = [this.paymentSearch.status];
      }
      const res = await api.post(api.core, "payment/partner/" + this.partner.code + "/list", body);
      if (res?.data?.status === "success") {
        this.payments = res.data.payments || [];
        this.paymentsTotal = res.data.total || 0;
      }
    } finally {
      this.paymentsLoading = false;
    }
  }

  onPaymentPageChange(page: number) {
    this.paymentsPage = page;
    this.reloadPayments();
  }

  resetPaymentSearch() {
    this.paymentSearch = {
      contains: "",
      status: "",
      start: "",
      end: "",
      minPrice: null,
      maxPrice: null,
    };
    this.paymentsPage = 1;
    this.reloadPayments();
  }

  async deletePartner(partner: Partner) {
    const response = await Swal.fire({
      title: "Supprimer ce partenaire",
      html: "Toutes les informations liées à ce partenaire seront supprimées",
      timer: 10000,
      icon: "error",
      timerProgressBar: true,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      didOpen: () => {
        // Swal.showLoading()
        // const b = Swal.getHtmlContainer().querySelector('b')
        // timerInterval = setInterval(() => {
        //     b.textContent = Swal.getTimerLeft()
        // }, 100)
      },
      willClose: () => {
        // clearInterval(timerInterval)
      },
    });
    if (response.isConfirmed) {
      const res = await api.get(api.core, "partner/delete/" + partner.uuid);
      if (res && res.data) {
        this.loadPartner();
        this.loadContracts();
      }
    }
  }

  createSub(partner: Partner) {
    // console.log(code)
    this.createAgency(partner);
    const refs = this.$refs as any;
    if (refs.editAgency) {
      refs.editAgency.show();
    }
  }

  createAgency(partner: Partner | null = null) {
    this.agency = new Partner();
    if (partner) {
      this.agency.parent = partner.id as any;
    }
  }

  editAgency(agency: Partner) {
    console.log(agency);

    this.agency = new Partner({ ...agency });
    (this.$refs as any).editAgency.show();
    this.agency.parent = this.partner;
    if (this.agency.code.includes(this.partner.code)) {
      this.agency.code = this.agency.code.replace(this.partner.code, "");
    }
    this.agency.code = helper.slugify(this.agency.code, "");
  }

  initCommission() {
    if (this.branchCategories.length > 0) {
      if (this.branchCategories[0].branches.length > 0) {
        this.loadMethods(this.branchCategories[0].branches[0]);
      }
    }
  }

  toggleMethodForPartner(method: PaymentMethod, partner: Partner) {
    const index = partner.paymentMethods.findIndex(
      (p: PaymentMethod) => p.id === method.id
    );
    console.log(index);
    if (index >= 0) {
      partner.paymentMethods.splice(index, 1);
    } else {
      partner.paymentMethods.push(method);
    }
  }

  async sendEmail(code: string, link: string) {
    const response = await Swal.fire({
      title: "Envoyer un email",
      html: "Voulez-vous envoyer un lien en email à ce partenaire ?",
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Envoyer",
      confirmButtonAriaLabel: "Envoyer",
      cancelButtonText: "Annuler",
      cancelButtonAriaLabel: "Annuler",
    });
    if (response.isConfirmed) {
      this.$store.commit("loading");
      const res = await api.post(api.auth, "partner/send/link/mail", {
        code,
        link,
      });
      this.$store.commit("stopLoading");
      if (res && res.data) {
        Swal.fire({
          title: "Email envoyé",
          html: "L'email a été envoyé avec succès",
          icon: "success",
          showCancelButton: false,
          confirmButtonText: "OK",
          confirmButtonAriaLabel: "OK",
        });
      }
    }
  }

  async savePartner() {
    this.$store.commit("loading");
    let partner = { ...this.partner };
    delete partner.agencies;
    console.log(partner);
    // pc.branch = {slug: (pc.branch as any).slug, uuid: (pc.branch as any).uuid} as any
    const res = await api.post(api.core, "partner/edit", { partner });
    // return
    this.$store.commit("stopLoading");
    if (res && res.data) {
      const refs = this.$refs as any;
      if (refs.editPartner) {
        refs.editPartner.hide();
      }
      this.loadPartner();
    }
  }

  async saveAgency() {
    this.$store.commit("loading");
    let agency: any = { ...this.agency };
    agency.parent = this.partner.id;
    delete agency.agencies;
    // pc.branch = {slug: (pc.branch as any).slug, uuid: (pc.branch as any).uuid} as any
    const res = await api.post(api.core, "partner/edit", { partner: agency });
    // return
    this.$store.commit("stopLoading");
    if (res && res.data) {
      const refs = this.$refs as any;
      if (refs.editAgency) {
        refs.editAgency.hide();
      }
      this.loadPartner();
    }
  }

  editUser(user: Partner) {
    this.user = new Partner(user);
    (this.$refs as any).editUser.show();
  }

  createUser() {
    this.user = new Partner();
    this.user.code = this.partner.code;
    (this.$refs as any).editUser.show();
  }

  isMethodActiveForPartner(method: PaymentMethod, partner: Partner) {
    return partner.paymentMethods.find((p: PaymentMethod) => p.id === method.id)
      ? true
      : false;
  }

  async loadPartner() {
    this.isLoading = true;
    const res = await api.get(
      api.core,
      "partner/get/" + this.$route.params.code
    );
    this.isLoading = false;
    if (res && res.data) {
      this.partner = new Partner(res.data.partner);
    }
  }

  async toggleTenant(tenant: Tenant) {
    if (this.partner && this.partner.id) {
      this.$store.commit("loading");
      const res = await api.get(
        api.core,
        "partner/" + this.partner.id + "/toggle/tenant/" + tenant.code
      );
      if (res && res.data && res.data.partner) {
        this.partner = new Partner(res.data.partner);
      }
      this.$store.commit("stopLoading");
    }
  }

  async toggleRole(data: any) {
    const role: any = data.role;
    const tenant: Tenant = data.tenant;
    // console.log(data)
    let code = role.code.startsWith("ROLE_") ? role.code : "ROLE_" + role.code;
    if (tenant) {
      code += "_" + tenant.code.toUpperCase();
    }
    const action = this.partner.roles.includes(code) ? "remove" : "append";
    const list = role.getlist();

    if (role instanceof Role) {
      list.forEach((r: string) => {
        if (tenant) {
          r += "_" + tenant.code.toUpperCase();
        }
        // console.log(r)
        const index = this.partner.roles.indexOf(r);
        if (index !== -1) {
          this.partner.roles.splice(index, 1);
        }
      });
    }

    if (action === "remove") {
      // list.forEach((r: string) => {
      const index = this.partner.roles.indexOf(code);
      if (index !== -1) {
        this.partner.roles.splice(index, 1);
      }
      // })
    } else {
      this.partner.roles.push(code);
      list.forEach((r: string) => {
        if (tenant) {
          r += "_" + tenant.code.toUpperCase();
        }
        const index = this.partner.roles.indexOf(r);
        if (index === -1) {
          this.partner.roles.push(r);
        }
      });
    }
    // console.log('toggle')
    this.$store.commit("loading");
    const res = await api.post(api.core, "partner/edit", {
      partner: this.partner,
    });
    if (res && res.data && res.data.partner) {
      this.partner = new Partner(res.data.partner);
    }

    this.$store.commit("stopLoading");
    // console.log(role)
  }

  async deleteCustomLink(link: PartnerLink) {
    const response = await Swal.fire({
      title: "Supprimer ce lien",
      html: "Voulez-vous supprimer ce lien ?",
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Supprimer",
      confirmButtonAriaLabel: "Supprimer",
      cancelButtonText: "Annuler",
      cancelButtonAriaLabel: "Annuler",
    });
    if (response.isConfirmed) {
      this.$store.commit("loading");
      const res = await api.get(
        api.core,
        "partner/delete/custom/link/" + link.id
      );
      this.$store.commit("stopLoading");
      if (res && res.data) {
        this.loadPartner();
        this.loadLinkList();
      }
    }
  }
  async loadPartnerMethods() {
    // this.$store.commit('loading')
    const res = await api.get(
      api.core,
      "partner/method/list/" + this.$route.params.code
    );
    if (res && res.data) {
      this.methods = [];
      res.data.methods?.forEach((p: PaymentMethod) => {
        this.methods.push(new PaymentMethod(p));
      });
    }
    // this.$store.commit('stopLoading')
  }

  async loadContracts() {
    this.loadingContracts = true;
    const res = await api.post(api.core, "contract/search", {
      searched: {
        partner: this.$route.params.code,
        page: this.contractPage,
        perPage: 10,
        branch: null,
        customer: null,
        insurer: null,
        manager: null,
        police: null,
        effetMin: null,
        effetMax: null,
        expireMin: null,
        expireMax: null,
        createMin: null,
        createMax: null,
      },
    });
    if (res && res.data) {
      this.contracts = [];
      res.data.contracts?.forEach((c: any) => {
        const occ = new Contract(c);
        this.contracts.push(occ);
      });
    }
    this.loadingContracts = false;
  }

  getAgencyNameByCode(code: string) {
    console.log(code, "code");
    if (this.partner) {
      const agency = this.partner.agencies.find((agency: Partner) => {
        return agency.code === code;
      });
      return agency ? agency.name : code;
    }
  }

  async loadUsers() {
    this.loadingUsers = true;
    const res = await api.get(
      api.auth,
      "partner/user/list/" + this.$route.params.code
    );
    this.loadingUsers = false;

    if (res && res.data && res.data.users) {
      this.users = [];
      res.data.users.forEach((p: any) => {
        const occ = new Partner(p);
        this.users.push(occ);
      });
    }
  }

  async loadAgencies() {
    this.loadingUsers = true;
    const res = await api.get(
      api.core,
      "partner/agencies/list/" + this.$route.params.code
    );
    if (res && res.data && res.data.agencies) {
      this.agencies = [];
      res.data.agencies.forEach((p: any) => {
        const occ = new Partner(p);
        this.agencies.push(occ);
      });
    }
    this.loadingUsers = false;
  }

  async loadMethods(branch: Branch) {
    this.loadingEngineMethod = true;
    const res = await api.get(
      api.core,
      "engine/method/list/global/" +
      branch.slug +
      "/version/" +
      branch.engineVersion
    );
    if (res && res.data) {
      this.engineMethods = [];
      res.data.methods.forEach((m: EngineMethod) => {
        const occ = new EngineMethod(m);
        this.engineMethods.push(occ);
      });

      // this.engines = []
      // res.data.engines.forEach((e: Engine) => {
      //     const occ = new Engine(e)
      //     this.engines.push(occ)
      // })
      // console.log(this.branch)
    }
    this.loadingEngineMethod = false;
  }
}
</script>
<style scoped>
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.2s;
}

.slide-left-leave-from {
  transition: all 0.2s;
}

.slide-left-enter {
  opacity: 0;
  transform: translateY(50%);
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-50%);
}

.modal-xl .modal-content {
  height: 100%;
}

.badge-design {
  padding: 0rem !important;
  background: white;
  width: 40rem;
}

.badge-design>img {
  padding: 0rem !important;
  object-fit: cover;
  width: 100%;
}

.badge-design .content-qr {
  background: url("../../../assets/logo-trans.svg") no-repeat center;

  background-size: cover;
  padding: 5rem;
}
</style>
